export default "__VITE_ASSET__Dkt0OdeM__"